import { createFileRoute } from "@tanstack/react-router"
import { BulkUpdateGuide } from "@/features/change-projects/components/BulkUpdateGuide"

export const Route = createFileRoute("/(authenticated)/bulk-updates/info")({
  component: BulkUpdateGuide,
})
